"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPostOnceAccountingSyncOp = isPostOnceAccountingSyncOp;
const accounting_invoice_payment_sync_contract_js_1 = require("./accounting-invoice-payment-sync.contract.js");
const accounting_invoice_void_sync_contract_js_1 = require("./accounting-invoice-void-sync.contract.js");
const accounting_absorbed_cc_fee_sync_contract_js_1 = require("./accounting-absorbed-cc-fee-sync.contract.js");
const accounting_escrow_to_actual_sync_contract_js_1 = require("./accounting-escrow-to-actual-sync.contract.js");
const accounting_platform_charge_sync_contract_js_1 = require("./accounting-platform-charge-sync.contract.js");
const accounting_split_tranche_recognition_sync_contract_js_1 = require("./accounting-split-tranche-recognition-sync.contract.js");
const accounting_withdrawal_sync_contract_js_1 = require("./accounting-withdrawal-sync.contract.js");
/**
 * Ledger postings that must not be re-sent to the provider on reconcile when the
 * idempotency row is already SUCCEEDED (reconcile still updates payload hash).
 */
function isPostOnceAccountingSyncOp(operation) {
    return ((0, accounting_platform_charge_sync_contract_js_1.isRecordPlatformChargeAccountingSyncOp)(operation) ||
        (0, accounting_invoice_payment_sync_contract_js_1.isAllocatePaymentAccountingSyncOp)(operation) ||
        (0, accounting_escrow_to_actual_sync_contract_js_1.isRecordEscrowToActualReleaseAccountingSyncOp)(operation) ||
        (0, accounting_split_tranche_recognition_sync_contract_js_1.isRecognizeSplitTrancheRevenueAccountingSyncOp)(operation) ||
        (0, accounting_absorbed_cc_fee_sync_contract_js_1.isPostAbsorbedCcFeeLedgerAccountingSyncOp)(operation) ||
        (0, accounting_withdrawal_sync_contract_js_1.isWithdrawalTransferAccountingSyncOp)(operation) ||
        operation === accounting_invoice_void_sync_contract_js_1.ACCOUNTING_SYNC_OPERATION_VOID_XERO_INVOICE);
}
